module.exports = __webpack_public_path__ + "img/Sponsors.165f4c9d.png";